// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n/**\n* Text sizes\n*/\n/**\n* Column settings\n*/\n/**\n* Font properties\n*/\n.proposalDetail[data-v-0a111c9c] .section {\n  padding-inline: 0 !important;\n}\n.title-date[data-v-0a111c9c]:first-letter {\n  text-transform: uppercase;\n}", ""]);
// Exports
module.exports = exports;
